import type { Assessment } from "../components/ui/school/assessment-management/assessment-card"

export const assessmentsData: Assessment[] = [
  {
    id: "1",
    title: "Intro to Robotics",
    category: "Engineering Path",
    status: "active",
    dueDate: "Oct 24, 2023",
    sharedWith: "3 Classes",
    type: "Practical",
    questions: "15 Questions",
    resources: [
      { type: "pdf", icon: "pdf" },
      { type: "video", icon: "video" },
      { type: "doc", icon: "doc" },
      { type: "pdf", icon: "pdf" },
    ],
  },
  {
    id: "2",
    title: "Creative Writing",
    category: "Arts & Literature",
    status: "closed",
    dueDate: "Oct 10, 2023",
    sharedWith: "5 Classes",
    type: "Assignment",
    questions: "2 Prompts",
    resources: [{ type: "doc", icon: "doc" }],
    isAssigned: true,
  },
  {
    id: "3",
    title: "Basic Algebra Quiz",
    category: "Mathematics",
    status: "active",
    dueDate: "Oct 30, 2023",
    sharedWith: "4 Classes",
    type: "Quiz",
    questions: "20 Questions",
    resources: [
      { type: "pdf", icon: "pdf" },
      { type: "video", icon: "video" },
    ],
  },
  {
    id: "4",
    title: "Biology Lab Report",
    category: "Science",
    status: "draft",
    dueDate: "Nov 5, 2023",
    sharedWith: "2 Classes",
    type: "Lab Work",
    questions: "5 Sections",
    resources: [
      { type: "pdf", icon: "pdf" },
      { type: "doc", icon: "doc" },
    ],
  },
]
